import { Box, List, ListItemButton } from '@mui/material'
import { Draggable } from 'react-beautiful-dnd'
import { AccountDoc, EventDoc, UserSettingsDoc } from 'types/api/changes'
import { Model } from 'types/model'
import Item from './Item'
import { useRef } from 'react'
import { makeStyles } from '@mui/styles'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import { CalendarRange } from 'types/components/calendar'
import { useEventPopover } from 'components/calendar/eventPopover/EventPopoverProvider'

interface TFMEventsListProps {
  events?: EventDoc[]
  showEvent?: string
  setShowEvent: (s: string) => void
  droppableId: string
  userSettings?: Model<UserSettingsDoc>
  account?: Model<AccountDoc>
}

const useStyles = makeStyles({
  root: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiTouchRipple-root span': {
      backgroundColor: 'transparent !important',
      opacity: 0.3
    },
    '&:selected': {
      backgroundColor: 'transparent !important'
    }
  }
})

export default function TFMEventsList(props: TFMEventsListProps) {
  const focusOnEvent = props.events?.find((event) => {
    const uniqueId = `${event._id}${event.StartDate}`
    return (
      event._rev?.length === 0 ||
      uniqueId === LocalStorage.get(LocalStorageKey.FOCUS_EVENT)
    )
  })

  const focusId = `${focusOnEvent?.id}${focusOnEvent?.StartDate}`

  const listRef = useRef<HTMLDivElement | null>(null)
  LocalStorage.remove(LocalStorageKey.FOCUS_EVENT)
  //to scroll to recently updated item
  setTimeout(() => {
    if (focusOnEvent) {
      const listElement = listRef.current

      if (listElement) {
        listElement.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        })
      }
    }
  }, 50)

  return (
    <List>
      {(props.events ?? []).map((item, index) => {
        const uniqueId = `${item._rev ?? item.id ?? item._id}${item.StartDate}`
        return (
          <Draggable
            isDragDisabled={
              item.Recurrence !== undefined &&
              item.Recurrence !== null &&
              typeof item.Recurrence !== 'string'
            }
            key={uniqueId}
            draggableId={uniqueId}
            index={index}
          >
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <ListItemButton
                  ref={
                    item._rev?.length === 0 || uniqueId === focusId
                      ? listRef
                      : undefined
                  }
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent'
                    },
                    '&.Mui-focusVisible': {
                      backgroundColor: 'transparent'
                    },
                    ':hover': {
                      backgroundColor: 'transparent'
                    },
                    '& .MuiTouchRipple-root span': {
                      backgroundColor: 'transparent !important',
                      opacity: 0.3
                    },
                    padding: '0px 16px 0px 16px',
                    textAlign: 'unset !important'
                  }}
                >
                  <div style={{ width: '100%' }}>
                    {buildItem({
                      index: index,
                      item: item,
                      account: props.account,
                      userSettings: props.userSettings,
                      showEvent: props.showEvent,
                      setShowEvent: props.setShowEvent,
                      droppableId: props.droppableId
                    })}
                  </div>
                </ListItemButton>
              </div>
            )}
          </Draggable>
        )
      })}
      <Box height={80} />
    </List>
  )
}

interface ListItemProps {
  userSettings?: Model<UserSettingsDoc>
  account?: Model<AccountDoc>
  index: number
  item: EventDoc
  showEvent?: string
  setShowEvent: (s: string) => void
  droppableId: string
}

function buildItem(props: ListItemProps) {
  const { closePopover } = useEventPopover()
  return (
    <div
      style={{
        width: '100%',
        overflow: 'hidden',
        margin: '8px 0'
      }}
    >
      <Item
        droppableId={props.droppableId}
        item={props.item}
        setShowEvent={props.setShowEvent}
        withToggle={props.item.someday != '1'}
        account={props.account}
        userSettings={props.userSettings}
        event={props.item}
        open={props.showEvent === props.item.id}
        setOpen={function (b: boolean): void {}}
        onClose={() => {
          console.log('calling close')
          closePopover()
        }}
      />
    </div>
  )
}
